import { useRouter } from 'next/navigation'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useOpenableControls } from '../../generic-hooks'
import { useGlobalConfigContext } from '../../global-config'
import {
  LoginRegistrationUserLoginModal,
  updateGlobalConfigWithPreferredLanguageAfterLogin,
} from '../../login-registration'
import { urlResolverGetAccountChangePage } from '../../url-handling'

import { ContactPageFlatCta } from './ContactPageFlatCta'

export const ContactPageAccountCta: FC<{
  isUserLoggedIn: boolean
}> = ({ isUserLoggedIn }) => {
  const modalControls = useOpenableControls()
  const config = useGlobalConfigContext()
  const router = useRouter()

  const redirectToAccountChangePageAfterLoginWithPreferredLanguage = async (
    afterLoginPromiseWithPreferredLanguage: Promise<string | undefined>,
  ): Promise<void> => {
    const globalConfigWithPreferredLanguage =
      await updateGlobalConfigWithPreferredLanguageAfterLogin(
        config,
        afterLoginPromiseWithPreferredLanguage,
      )
    router.replace(
      urlResolverGetAccountChangePage(globalConfigWithPreferredLanguage),
    )
  }

  return (
    <>
      {isUserLoggedIn ? (
        <ContactPageFlatCta<'a'>
          data-qa-id="qa-id-help-center-account-management"
          href={urlResolverGetAccountChangePage(config)}
          slots={{ root: 'a' }}
        >
          <FormattedMessage id="helpCenter.accountManagement.dialog.title.new" />
        </ContactPageFlatCta>
      ) : (
        <ContactPageFlatCta
          data-qa-id="qa-id-help-center-account-management"
          onClick={modalControls.handleOpen}
        >
          <FormattedMessage id="helpCenter.accountManagement.dialog.title.new" />
        </ContactPageFlatCta>
      )}
      <LoginRegistrationUserLoginModal
        afterLoggedIn={(
          afterLoginPromiseWithPreferredLanguage: Promise<string | undefined>,
        ): void => {
          void redirectToAccountChangePageAfterLoginWithPreferredLanguage(
            afterLoginPromiseWithPreferredLanguage,
          )
        }}
        onClose={modalControls.handleClose}
        open={modalControls.isOpen}
      />
    </>
  )
}
